import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import { getReferralStats } from '../api/client';
import { Copy, Share, Check } from '../components/icons';

export default function PartnerPage({ onNavigate }) {
  const [stats, setStats] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getReferralStats()
      .then(data => setStats(data))
      .catch(() => {
        const id = window.Telegram?.WebApp?.initDataUnsafe?.user?.id;
        setStats({
          link: id ? `https://app.fix-hub.de/go?ref=${id}` : '',
          tg_link: id ? `https://t.me/fixclubde_bot?startapp=ref_${id}` : '',
          invited: 0,
          active: 0,
        });
      });
  }, []);

  // link — универсальная (/go, работает из WhatsApp и любых мессенджеров);
  // tg_link — прямая t.me для шаринга внутри Telegram.
  const link = stats?.link || '';
  const tgLink = stats?.tg_link || link;

  const handleCopy = () => {
    navigator.clipboard.writeText(link)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
  };

  const handleShare = () => {
    const text = 'Присоединяйтесь к Fix-Hub — клубу для строительных фирм';
    const shareUrl = 'https://t.me/share/url?url=' + encodeURIComponent(tgLink) + '&text=' + encodeURIComponent(text);
    const tg = window.Telegram?.WebApp;
    if (tg?.openTelegramLink) tg.openTelegramLink(shareUrl);
    else window.open(shareUrl, '_blank');
  };

  if (!stats) {
    return (
      <div>
        <Header
          title="Партнёрская программа"
          left={
            <div
              onClick={() => onNavigate('home')}
              style={{ fontSize: 15, color: 'var(--accent)', cursor: 'pointer', minWidth: 50 }}
            >
              ← Назад
            </div>
          }
        />
        <div style={{ padding: '16px 16px 100px', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center' }}>
          <div style={{ color: 'var(--text-tertiary)', fontSize: 15, marginTop: 40 }}>Загрузка…</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header
        title="Партнёрская программа"
        left={
          <div
            onClick={() => onNavigate('home')}
            style={{ fontSize: 15, color: 'var(--accent)', cursor: 'pointer', minWidth: 50 }}
          >
            ← Назад
          </div>
        }
      />
      <div style={{ padding: '16px 16px 100px', display: 'flex', flexDirection: 'column', gap: 16 }}>

        {/* Пояснительный текст */}
        <div style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          Приглашайте строительные фирмы по своей ссылке. Засчитываются активные клиенты.
        </div>

        {/* Карточка «Ваша ссылка» */}
        <div style={{
          background: 'var(--bg-card)', borderRadius: 16, padding: '14px 16px',
          border: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: 12,
        }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>Ваша ссылка</div>
          <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: -6, lineHeight: 1.4 }}>
            Работает везде: WhatsApp, Telegram, соцсети — открывает приложение клуба
          </div>
          <div style={{
            background: 'var(--bg-elevated)', border: '1px solid var(--border)',
            borderRadius: 12, padding: '10px 14px',
            fontFamily: 'monospace', fontSize: 13, color: 'var(--text-primary)',
            wordBreak: 'break-all', lineHeight: 1.5,
          }}>
            {link || '—'}
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={handleCopy}
              style={{
                flex: 1, padding: '11px 0', borderRadius: 12, border: '1px solid var(--border)',
                background: 'var(--bg-elevated)', color: 'var(--text-primary)',
                fontSize: 14, fontWeight: 600, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              }}
            >
              {copied ? <><Check size={15} /> Скопировано</> : <><Copy size={15} /> Скопировать</>}
            </button>
            <button
              onClick={handleShare}
              style={{
                flex: 1, padding: '11px 0', borderRadius: 12, border: 'none',
                background: 'var(--accent)', color: '#0A0A0A',
                fontSize: 14, fontWeight: 700, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              }}
            >
              <Share size={15} /> Поделиться
            </button>
          </div>
        </div>

        {/* Плитки статистики */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div style={{
            background: 'var(--bg-card)', borderRadius: 16, padding: '18px 16px',
            border: '1px solid var(--border)', textAlign: 'center',
          }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--text-primary)' }}>
              {stats.invited ?? 0}
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 6 }}>Привёл</div>
          </div>
          <div style={{
            background: 'var(--bg-card)', borderRadius: 16, padding: '18px 16px',
            border: '1px solid var(--border)', textAlign: 'center',
          }}>
            <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--accent)' }}>
              {stats.active ?? 0}
            </div>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 6 }}>Активных клиентов</div>
          </div>
        </div>

      </div>
    </div>
  );
}
